var React = require('react');

function FeatureTimeAttendance (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"25","cy":"25","r":"25","fill":"#FBE8F2","key":0}),React.createElement("path",{"fill":"#EA78B0","fillRule":"nonzero","d":"M25 11c-7.732 0-14 6.268-14 14s6.268 14 14 14 14-6.268 14-14a14 14 0 0 0-14-14zm12.193 14c0 6.734-5.459 12.193-12.193 12.193S12.807 31.734 12.807 25 18.266 12.807 25 12.807A12.193 12.193 0 0 1 37.193 25z","key":1}),React.createElement("path",{"fill":"#B01863","fillRule":"nonzero","d":"M28.788 30.795l-4.584-3.33a.683.683 0 0 1-.277-.548v-9.012a.68.68 0 0 1 .678-.678h.787a.68.68 0 0 1 .677.678v8.259l3.98 2.895a.676.676 0 0 1 .147.949l-.463.637a.682.682 0 0 1-.949.148l.004.002z","key":2})]));
}

FeatureTimeAttendance.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = FeatureTimeAttendance;

FeatureTimeAttendance.default = FeatureTimeAttendance;
